import { render, staticRenderFns } from "./goodsList1.vue?vue&type=template&id=fe5acb42&scoped=true&"
import script from "./goodsList1.vue?vue&type=script&lang=js&"
export * from "./goodsList1.vue?vue&type=script&lang=js&"
import style0 from "./goodsList1.vue?vue&type=style&index=0&id=fe5acb42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5acb42",
  null
  
)

export default component.exports